import React from 'react';
import {
    Box,
    Typography,
    Card,
    CardContent,
    IconButton,
    useTheme
} from '@mui/material';
import { ReactComponent as ArrowUpwordCorner } from '../../images/ArrowCorner.svg';

interface WSDashboardCardProps {
    title: string;
    value: string | number;
    percentage: string;
    icon: React.ReactNode;
    bottomIcon?: React.ReactNode;
    onClick?: () => void;
    percentageColor?: string;
    bgColor?: string;
    height?: string | number;
}

const WSDashboardCard: React.FC<WSDashboardCardProps> = ({
    title,
    value,
    percentage,
    icon,
    onClick,
    percentageColor = '#098963',
    bgColor = '#E7F6F2',
    bottomIcon,
    height,
}) => {
    const theme = useTheme();

    return (
        <Card
            sx={{
                borderRadius: '16px',
                boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.05)',
                backgroundColor: '#fff',
                position: 'relative',
                height: height || 'auto',
                display: 'flex',
                flexDirection: 'column',
                '&:hover': {
                   // transform: 'translateY(-4px)',
                    boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.1)',
                    border:'1px solid #CEEEE5'
                },
            }}
        >
            <CardContent
                sx={{
                    paddingBottom: '16px !important',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    flexGrow: 1, // ensures content takes full height
                }}
            >
                {/* Title and Icon */}
                <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                    <Box display="flex" alignItems="center" gap={1}>
                        {icon}
                        <Typography variant="subtitle2" color="text.secondary">
                            {title}
                        </Typography>
                    </Box>
                </Box>

                {/* Value */}
                <Typography
                    variant="h4"
                    fontWeight="bold"
                    mb={1}
                    sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}
                >
                    {value}
                </Typography>

                {/* Percentage and arrow */}
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Box
                        display="flex"
                        alignItems="center"
                        gap={0.5}
                        px={1}
                        py={0.5}
                        borderRadius="12px"
                        bgcolor={bgColor}
                        color={percentageColor}
                        fontSize="0.75rem"
                        fontWeight="500"
                    >
                        {bottomIcon && bottomIcon}
                        {percentage}
                    </Box>

                    <IconButton size="small" onClick={onClick}>
                        <ArrowUpwordCorner style={{ width: '100%', height: '100%' }} />
                    </IconButton>
                </Box>
            </CardContent>
        </Card>
    );
};

export default WSDashboardCard;
